// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueLazyload from 'vue-lazyload';
import "../static/css/index.css";
import ElementUI from 'element-ui'
import { Button, Select ,Input , Pagination, Dialog } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(ElementUI)

Vue.config.productionTip = false;
axios.defaults.withCredentials=true;
Vue.use(VueLazyload, {
  preLoad: 1.3,//提前加载高度（数字 1 表示 1 屏的高度）
  error:require('@/assets/wuneirong.jpg'),//图片加载失败时显示的图片
  loading: require('@/assets/wuneirong.jpg'),//图片加载状态下显示的图片
  attempt: 1 //加载错误后最大尝试次数
})

router.afterEach((to,from,next) => {  
  let locHash=location.hash;
  if(locHash!="#1" && locHash!="#2" && locHash!="#3" && locHash!="#4"){
    window.scrollTo(0,0); 
  } 
})


//模拟数据
// import './mock';

/* eslint-disable no-new */

import store from './store' 
Vue.prototype.$store = store

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js